import { useEffect } from 'react';

import { useTracking } from '@xing-com/crate-communication-tracking';

export const useCareerHubMainPageView = (topics?: string[]): void => {
  const { track } = useTracking<{ PropModules: string[] }>();
  useEffect(() => {
    if (topics) {
      track({
        type: 'pageview',
        channel: 'wbm/career_hub',
        page: 'wbm/career_hub/main_page',
        PropModules: topics.map((topic, index) => topic + '_' + (index + 1)),
      });
    }
  }, [topics, track]);
};

export default useCareerHubMainPageView;
